import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/pay/allinpayorder/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const deleteObj = (params, urlParams) => {
  return axios.request({
    url: '/pay/allinpayorder/' + params.id + '' + genURLParams(urlParams),
    method: 'DELETE',
    credentials: 'include',
    data: params
  })
}

export const searchByName = (params, urlParams) => {
  return axios.request({
    url: '/pay/allinpayorder/searchbyname/' + params.name + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getAll = (params, urlParams) => {
  return axios.request({
    url: '/pay/allinpayorder/all' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/pay/allinpayorder/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getMyCreatePage = (params, urlParams) => {
  return axios.request({
    url: '/pay/allinpayorder/getmycreatepage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const wechatGenerateOrder = (params, urlParams) => {
  return axios.request({
    url: '/pay/allinpayorder/wechatgenerateorder' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const wechatPayCallback = (params, urlParams) => {
  return axios.request({
    url: '/pay/allinpayorder/wechatpaycallback' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getMyPayPage = (params, urlParams) => {
  return axios.request({
    url: '/pay/allinpayorder/getmypaypage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

